var CryptoJS = require('crypto-js');

export const encrypt = (word: any) => {
  const keyBase64 = 'o9szYIOq1rRMiouNhNvaq96lqUvCekxR'; //TODO we need to use TOKEN as secret key
  var key = CryptoJS.enc.Base64.parse(keyBase64);
  var srcs = CryptoJS.enc.Utf8.parse(word);
  var encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export const decrypt = (word: any) => {
  const keyBase64 = 'o9szYIOq1rRMiouNhNvaq96lqUvCekxR';
  var key = CryptoJS.enc.Base64.parse(keyBase64);
  var decrypt = CryptoJS.AES.decrypt(word, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });
  return CryptoJS.enc.Utf8.stringify(decrypt).toString();
};

//DO NOT USE THIS!
export const encryptURL = (url: any) => {
  //STILL IN DEV

  //NB: ?,=,& are not encrypted!!
  //let res = url;
  let apiroute = '';
  let params = '';
  let arrayofparams = [];
  let arrayofcriptedparams: any = [];
  let resParams = '';
  if (url.indexOf('?') !== -1) {
    apiroute = url.slice(0, url.indexOf('?')+1);

    params = url.slice(url.indexOf('?') + 1, url.length);
    arrayofparams = params.split('&');

    arrayofcriptedparams = arrayofparams.map((stringparam: any) => {
      let paramwithVal = stringparam.split('=');
      return {
        [encrypt(paramwithVal[0])]: encrypt(paramwithVal[1]),
      };
    });

    //TODO separte with &
    arrayofcriptedparams.forEach((obj: any) => {
      Object.keys(obj).forEach((key) => {
        resParams += `${[key]}=${obj[key]}`;
      });
    });
  }

    //NB: ?,=,& are not encrypted!!

};
